import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

class ProductInventory extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.stockTimer = setInterval(() => this.refreshStock(), 30000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.stockTimer);
    this.stockRequest?.abort();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  async refreshStock() {
    if (document.hidden || this.stockLoading || !this.dataset.productUrl) return;
    this.stockLoading = true;
    this.stockRequest = new AbortController();
    try {
      const section = this.closest('.shopify-section');
      const id = section?.querySelector('product-form-component form input[name="id"]')?.value || new URL(location.href).searchParams.get('variant');
      const url = new URL(this.dataset.productUrl, location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);
      if (id) url.searchParams.set('variant', id);
      url.searchParams.set('_stock', Date.now());
      const response = await fetch(url, { cache: 'no-store', signal: this.stockRequest.signal });
      if (!response.ok || !this.isConnected) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const currentId = section?.querySelector('product-form-component form input[name="id"]')?.value || new URL(location.href).searchParams.get('variant');
      if (id !== currentId) return;
      const next = html.querySelector('product-inventory');
      if (next) morph(this, next, { childrenOnly: true });
    } catch {} finally { this.stockLoading = false; }
  }

  /**
   * Handles product select event by updating the inventory.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newInventory = html.querySelector('product-inventory');
        if (!newInventory) return;

        morph(this, newInventory, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-inventory] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
